import { Store } from '@ngrx/store'
import { StoreConnectors } from '../model/layers/generic-layer'
import { viewerActions } from '../../state/viewer/viewer.actions'

export class LayerPropertyStoreConnector {
    private readonly storeConnectors: StoreConnectors = {}

    constructor(private readonly store: Store) {}

    addVisibility(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchVisible = (layerName: string, visible: boolean): void => {
            this.store.dispatch(viewerActions.setLayerVisibility({ name: layerName, visible }))
        }
        return this
    }

    addOpacity(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchOpacity = (layerName: string, opacity: number): void => {
            this.store.dispatch(viewerActions.setLayerOpacity({ name: layerName, opacity }))
        }
        return this
    }

    addOpacityUnselected(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchOpacityUnselected = (
            layerName: string,
            opacity: number
        ): void => {
            this.store.dispatch(
                viewerActions.setLayerOpacityUnselected({ name: layerName, opacity })
            )
        }
        return this
    }

    addSaturation(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchSaturation = (layerName: string, saturation: number): void => {
            this.store.dispatch(viewerActions.setLayerSaturation({ name: layerName, saturation }))
        }
        return this
    }

    addShaderColor(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchShaderColor = (
            layerName: string,
            shaderColor: string
        ): void => {
            this.store.dispatch(viewerActions.setLayerShaderColor({ name: layerName, shaderColor }))
        }
        return this
    }

    addBrightness(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchBrightness = (layerName: string, brightness: number): void => {
            this.store.dispatch(viewerActions.setLayerBrightness({ name: layerName, brightness }))
        }
        return this
    }

    addContrast(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchContrast = (layerName: string, contrast: number): void => {
            this.store.dispatch(viewerActions.setLayerContrast({ name: layerName, contrast }))
        }
        return this
    }

    addSegmentationColor(): LayerPropertyStoreConnector {
        this.storeConnectors.dispatchSegmentationColor = (
            layerName: string,
            segmentationColor: string | undefined
        ): void => {
            this.store.dispatch(
                viewerActions.setLayerSegmentationColor({ name: layerName, segmentationColor })
            )
        }
        return this
    }

    build(): StoreConnectors {
        return this.storeConnectors
    }
}
